module.exports = __webpack_public_path__ + "img/cgq.5cd4d63d.png";